import React, { useState, useEffect, useContext } from 'react';
import { BackArrowSVG  } from '../../Video/Icons';
import stylesEarnings from './earnings.module.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import calenderIcon from '../../../assets/images/referral/calendar-line.png';
import Calender from '../../Calender';
import CalenderContext from '../../../context/CalenderContext';

type EarningsProps = {
  sticky?: boolean;
  title?: string;
  showCalender?: boolean;
  classAdd?: string;
}

const Earnings: React.FC<EarningsProps> = ({sticky = false, title, showCalender = false, classAdd = ''}) => {

  
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isOpenCalender, setIsOpenCalender] = useState(false);

  const { isCalenderOpen, setIsCalenderOpen } = useContext(CalenderContext);
  const handleRedirectBack = () => {
   // window.history.back();
    navigate(-1);
  }

  const handleOpenCalender = () => {
     setIsOpenCalender(true);
     setIsCalenderOpen(true);
  }

  const handleCloseCalender = () => {
    setIsOpenCalender(false);
    setIsCalenderOpen(false);
  }

  useEffect(() => {
    //console.log("isCalenderOpen", isCalenderOpen);
    if(isCalenderOpen === false){ 
      setIsOpenCalender(false);
    }else{
      setIsOpenCalender(true);
    }
    //console.log("isOpenCalender", isOpenCalender);
  }, [isCalenderOpen, isOpenCalender]);


  return (
     <>
    <div className={clsx(stylesEarnings['earnings-header'], sticky ? stylesEarnings.sticky : "", classAdd)}>
      <div className={clsx(stylesEarnings.left)}>
        <span className={stylesEarnings['back-arrow']} onClick={handleRedirectBack}><BackArrowSVG width={12} height={17} /></span> 
        <span className={stylesEarnings.title}>{ title ? title : t('myEarnings')}</span>
      </div>
      <div className={stylesEarnings.right}>
        {showCalender && <span className={stylesEarnings.smiley} onClick={handleOpenCalender}><img src={calenderIcon} alt="calenderIcon" width={24} height={24} /></span>}
      </div>
    </div>
    {isOpenCalender && <Calender isOpenCalender={isOpenCalender} closeCalenderHandler={handleCloseCalender} />}
     </>
  )
}

export default Earnings;